import { Link } from "react-router-dom";
// Page css
import "./css-components/home.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";

import headerimg from "./content/header_img.png"
import course1 from "./content/course1.png";
import course2 from "./content/course2.jpg";
import course3 from "./content/course3.jpg";
import ava1 from "./content/avatar1.jpg";
import ava2 from "./content/avatar2.jpg";
import ava3 from "./content/avatar3.jpg";
import ava4 from "./content/avatar4.jpg";
import ava5 from "./content/avatar5.jpg";
import Footermain from "./Footer_main";






function Home(){

        //  Show/Hide FAQ answer

            const faqs= document.querySelectorAll('.faq');

            faqs.forEach(faq=>{
                faq.addEventListener('click',()=>{
                    faq.classList.toggle('open');

                    // Change icon
                    const icon= faq.querySelector('.faq__icon i');
                    if(icon.className==="fa-solid fa-plus"){
                        icon.className="fa-solid fa-minus";
                    } else {
                        icon.className="fa-solid fa-plus";
                    }
                })
            });

      
    return(
        
        <>

        {/* =====================HEADER========================= */}

        <div>
          <header>
              <div className="container header__container">
                  <div className="header__left">
                        <h3>Grow your skills to advance your career path</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti nobis  laborum maiores,ipsam quas.</p>
                        <Link to="./courses" className="btn btn-primary">Get Started</Link>

                  </div>
                  <div className="header__right">
                        <div className="header__right-image">
                            <img src={headerimg} alt="" />
                        </div>
                  </div>
              </div>
          </header>
        </div>

        {/* =====================Categories========================= */}

        <section className="categories">
            <div className="container categories__container">
                <div className="categories__left">
                    <h1>Categories</h1>
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate soluta quibusdam cupiditate ipsa, debitis maiores nobis?
                        </p>
                        <Link to="./courses" className="btn">Learn More</Link>

                </div>
                <div className="categories__right">
                   <article className="category">
                      <span className="category__icon"><i class="fa-brands fa-bitcoin"></i></span>
                         <h5>Blockchain</h5>
                     <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article> 

                   <article className="category">
                      <span className="category__icon"><i class="fa-brands fa-java"></i></span>
                          <h5>Java</h5>
                      <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article> 

                   <article className="category">
                     <span className="category__icon"><i class="fa-brands fa-python"></i></span>
                         <h5>Python</h5>
                     <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article> 

                   <article className="category">
                     <span className="category__icon"><i class="fa-brands fa-aws"></i></span>
                         <h5>AWS cloud</h5>
                     <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article> 

                   <article className="category">
                      <span className="category__icon"><i class="fa-brands fa-bitcoin"></i></span>
                          <h5>Blockchain</h5>
                       <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article> 

                   <article className="category">
                        <span className="category__icon"><i class="fa-brands fa-bitcoin"></i></span>
                             <h5>Blockchain</h5>
                         <p>Lorem ipsum, dolor sit amet consectetur adipisicing.</p>
                   </article>
                    </div>
            </div>
        </section>

          {/* =====================Our Popular courses========================= */}
        <section className="courses">
              <h2>Our Popular Courses</h2>
              <div className="container courses__container">
                  <article className="course">
                      <div className="course__image">
                          <img src={course1} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Media Website UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course2} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Smart Home Web Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>

                  <article className="course">
                      <div className="course__image">
                          <img src={course3} alt="" />
                      </div>
                      <div className="course__info">
                      <h4>Responsive Admin Dashboard UI Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est alias autem esse fugit omnis non eligendi? Dolorem, omnis!</p>
                      <Link to="./courses" className="btn btn-primary">Learn More</Link>
                      </div>
                  </article>
              </div>
        </section>

             {/* =================Frequently asked Questions===================== */}

        <section className="faqs">
        <h2>Frequently Asked Questions</h2>
            <div className="container faqs__container">
                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>

                <article className="faq">
                    <div className="faq__icon"><i class="fa-solid fa-plus"></i></div>
                    <div className="question__answer">
                        <h4>How do I find the right course for me?</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente magnam aut iusto atque distinctio id nulla saepe voluptates iste. Deserunt dolorum harum neque rerum optio excepturi voluptate omnis exercitationem velit?</p>
                    </div>
                </article>
            </div>
        </section>  

          {/* =================Testimonials===================== */}
          <section className="container testimonials__container">
              <h2>Students Testimonials</h2>
              <div>
        <Swiper 
         slidesPerView={1}
         spaceBetween={30}
         pagination={{
           clickable: true,
         }}
         modules={[Pagination]}
         breakpoints={{
            // when window width is >= 600px
            1000: {
              width: 1000,
              slidesPerView: 2,
            },
            450: {
                width: 500,
                slidesPerView: 2,
              }
              

        }}
         className="mySwiper"
         >

              <SwiperSlide> <article className="testimonial ">
                      <div className="avatar">
                          <img src={ava1} alt="" />
                      </div>
                      <div className="testimonial__info">
                          <h5>Heena B</h5>
                          <small>Student</small>
                      </div>
                      <div className="testimonial__body">
                          <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita nostrum corporis voluptate deleniti rerum nisi consequuntur magnam molestiae sunt aut eaque blanditiis fugit ratione sed aspernatur
                          </p>
                      </div>
                  </article></SwiperSlide>

                  <SwiperSlide> <article className="testimonial ">
                      <div className="avatar">
                          <img src={ava2} alt="" />
                      </div>
                      <div className="testimonial__info">
                          <h5>Hemant Ag</h5>
                          <small>Web Developer</small>
                      </div>
                      <div className="testimonial__body">
                          <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita nostrum corporis voluptate deleniti rerum nisi consequuntur magnam molestiae sunt aut eaque blanditiis fugit ratione sed aspernatur
                          </p>
                      </div>
                  </article></SwiperSlide>

                  <SwiperSlide><article className="testimonial ">
                      <div className="avatar">
                          <img src={ava3} alt="" />
                      </div>
                      <div className="testimonial__info">
                          <h5>Avinash K</h5>
                          <small>Student</small>
                      </div>
                      <div className="testimonial__body">
                          <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita nostrum corporis voluptate deleniti rerum nisi consequuntur magnam molestiae sunt aut eaque blanditiis fugit ratione sed aspernatur
                          </p>
                      </div>
                  </article></SwiperSlide>

                  <SwiperSlide> <article className="testimonial ">
                      <div className="avatar">
                          <img src={ava4} alt="" />
                      </div>
                      <div className="testimonial__info">
                          <h5>Chandni J</h5>
                          <small>Student</small>
                      </div>
                      <div className="testimonial__body">
                          <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita nostrum corporis voluptate deleniti rerum nisi consequuntur magnam molestiae sunt aut eaque blanditiis fugit ratione sed aspernatur
                          </p>
                      </div>
                  </article></SwiperSlide>

                  <SwiperSlide><article className="testimonial ">
                      <div className="avatar">
                          <img src={ava5} alt="" />
                      </div>
                      <div className="testimonial__info">
                          <h5>Aman S</h5>
                          <small>Teacher</small>
                      </div>
                      <div className="testimonial__body">
                          <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita nostrum corporis voluptate deleniti rerum nisi consequuntur magnam molestiae sunt aut eaque blanditiis fugit ratione sed aspernatur
                          </p>
                      </div>
                  </article></SwiperSlide>
                  </Swiper>
              </div>
          </section>
         

            {/* =================DFooter===================== */}

            <Footermain/>
     </>
    )
}
export default Home;